import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { hlm } from '@spartan-ng/brain/core';
import { BrnSelectOptionDirective } from '@spartan-ng/brain/select';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [{ directive: BrnSelectOptionDirective, inputs: ['disabled', 'value'] }],
  host: {
    '[class]': '_computedClass()',
  },
  template: `<ng-content />`,
})
export class HlmSelectOptionComponent {
  protected readonly _brnSelectOption = inject(BrnSelectOptionDirective, { host: true });
  public readonly class = input<ClassValue>('');
  protected readonly _computedClass = computed(() =>
    hlm(
      'relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 px-3 text-sm outline-none hover:bg-muted hover:text-muted-foreground data-[active]:bg-primary/10 data-[active]:text-primary data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[state=checked]:bg-primary/20 data-[state=checked]:text-primary data-[state=checked]:font-medium data-[state=checked]:hover:bg-primary/20',
      this.class()
    )
  );
}
